import { render } from "./UserLevelTd.vue?vue&type=template&id=c92e3cb2&scoped=true"
import script from "./UserLevelTd.vue?vue&type=script&lang=js"
export * from "./UserLevelTd.vue?vue&type=script&lang=js"

import "./UserLevelTd.vue?vue&type=style&index=0&id=c92e3cb2&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c92e3cb2"]])

export default __exports__